import { BLOB_CONFIG as DEFAULT_BLOB_CONFIG } from './blobConfig';
import { BLOB_CONFIG as AMPHORA_BLOB_CONFIG } from './blobConfigAmphora';
import { BLOB_CONFIG as SILVER_EROS_BLOB_CONFIG } from './blobConfigSilverEros';
import { BLOB_CONFIG as AI_ORACLE_BLOB_CONFIG } from './blobConfigAIOracle';
import { BLOB_CONFIG as FACE_SCANNER_BLOB_CONFIG } from './blobConfigFaceScanner';
import { BLOB_CONFIG as PROBIOTIC_BLOB_CONFIG } from './blobConfigProBiotic';
import { BLOB_CONFIG as NEURO_IMPLANT_BLOB_CONFIG } from './blobConfigNeuroImplant';
import { BLOB_CONFIG as AFTERLIFE_ARCHIVE_BLOB_CONFIG } from './blobConfigAfterlifeArchive';

export function normalizeArtefactName(name) {
  if (typeof name !== 'string') return '';
  return name.toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
}

export function isProbioticArchitectureName(name) {
  const n = normalizeArtefactName(name);
  return n.includes('probiotic architecture') || n.includes('gut architecture') || n.includes('probiotic');
}

export function isAfterlifeArchiveName(name) {
  const n = normalizeArtefactName(name);
  return n.includes('afterlife archive');
}

export function isFaceScannerName(name) {
  const n = normalizeArtefactName(name);
  return n.includes('face scanner') || n.includes('eye scanner');
}

export function isCellularRegenerationName(name) {
  const n = normalizeArtefactName(name);
  return n.includes('cellular regeneration') || n.includes('silver eros') || (n.includes('silver') && n.includes('eros'));
}

export function usesReducedBlobLighting(name) {
  return (
    isAfterlifeArchiveName(name) ||
    isFaceScannerName(name) ||
    isProbioticArchitectureName(name) ||
    isCellularRegenerationName(name)
  );
}

/**
 * Map exhibition persona / artefact labels to tuned blob shader presets.
 * First matching rule wins (keep specific multi-word phrases before loose substrings).
 */
export function resolveArtefactBlobConfig(artefactName) {
  const n = normalizeArtefactName(artefactName);
  if (!n) return DEFAULT_BLOB_CONFIG;

  if (isCellularRegenerationName(n)) {
    return SILVER_EROS_BLOB_CONFIG;
  }
  if (n.includes('medical oracle')) {
    return AI_ORACLE_BLOB_CONFIG;
  }
  if (n.includes('ai oracle')) {
    return AI_ORACLE_BLOB_CONFIG;
  }
  if (isFaceScannerName(n)) {
    return FACE_SCANNER_BLOB_CONFIG;
  }
  if (isProbioticArchitectureName(n)) {
    return PROBIOTIC_BLOB_CONFIG;
  }
  if (n.includes('neuro implant')) {
    return NEURO_IMPLANT_BLOB_CONFIG;
  }
  if (isAfterlifeArchiveName(n)) {
    return AFTERLIFE_ARCHIVE_BLOB_CONFIG;
  }
  if (
    n.includes('artificial womb') ||
    n.includes('external womb') ||
    n.includes('amphora')
  ) {
    return AMPHORA_BLOB_CONFIG;
  }

  return DEFAULT_BLOB_CONFIG;
}
